module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "head",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/005_contents#rack"
    }
  }, [_vm._v("♦ ACKNOWLEDGEMENTS ♦")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m grateful to the Most High God, Master Creator for without Him I would not be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to my five heartbeats, The Royals, for they are amazing in assistance and encouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to Angela “Kim” Steed. You are and have been a constant and consistent supported, fan, and friend. Thank you for your love and for riding this adventure with me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to Portia Davis Mann who showed me what abundance looked like. She gave me every opportunity to use my gift and supported me as her heart and the Lord led.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to J.L Woodson, graphic designer extraordinaire. This cover is amazing! Shall your gifts always make room for you wherever you go.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to my awesome team of beta readers, Karen D. Bradley, Felicia Thomas, and Eileen Kiley Goeckler. Your time, service, energy, and feedback are abundantly appreciated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A special thank you to London St. Charles who was my spirited cheerleader. Your daily calls and check-ins made this process so much easier. You really have a way with words.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to the best tribe in the universe, Naleighna Kai’s Tribe Called Success. You’re not just a literary group; you’re my family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A very special thank you to my developmental editor and friend, Boss Lady Lissa Woodson. I pray for you daily and thank God for the person you are and the patience you have with me. My gratitude is eternal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To anyone that I didn’t mention, you are loved and you support by word or deed made every minute of my life worth living.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d1a0072","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_acknowledgements.vue
// module id = 72
// module chunks = 0